import React from "react";
import { Helmet } from "react-helmet";
import { graphql, useStaticQuery } from "gatsby";

const Header = ({ location, pageTitle, pageDescription }) => {
  const { site } = useStaticQuery(graphql`
    query HeaderSiteMetadataQuery {
      site {
        siteMetadata {
          title
          description
          siteUrl
        }
      }
    }
  `);

  const siteMetadata = site?.siteMetadata || {};
  const title = pageTitle || siteMetadata.title;
  const metaDescription = pageDescription || siteMetadata.description;
  
  const siteUrl = (siteMetadata.siteUrl || "").replace(/\/$/, ""); // no trailing slash

  // `location` is only automatically passed to Gatsby page components.
  // When this component is rendered elsewhere (or during SSR), `location` may be undefined.
  const pathname =
    location?.pathname ??
    (typeof window !== "undefined" ? window.location.pathname : "/");

  const canonicalPath = pathname === "/" ? "" : pathname.replace(/\/$/, "");
  const canonicalUrl = siteUrl ? `${siteUrl}${canonicalPath || "/"}` : undefined;

  
  const ogImage = siteUrl ? `${siteUrl}/logo.png` : undefined;
  return <Helmet
        title={title}
        link={canonicalUrl ? [{ rel: `canonical`, href: canonicalUrl }] : []}

        meta={[
          {
            name: `description`,
            content: metaDescription,
          },
          {
            property: `og:title`,
            content: title,
          },
          ...(canonicalUrl
            ? [
                {
                  property: `og:url`,
                  content: canonicalUrl,
                },
              ]
            : []),
          {
            property: `og:description`,
            content: metaDescription,
          },
          ...(ogImage
            ? [
                {
                  property: `og:image`,
                  content: ogImage,
                },
              ]
            : []),
          {
            property: `og:type`,
            content: `website`,
          }
        ]}
      >
      
        <script async 
                src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7221946839680198"
                crossOrigin="anonymous">
        </script>
        <script>
          {`(adsbygoogle = window.adsbygoogle || []).push({});`}
        </script>   
   
      </Helmet>;

};

export default Header;